import React, { useEffect } from 'react'
import { useState } from 'react'
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import * as mdt from '../../../../common/modaltypes'
import moment from 'moment'
import { sortTableData } from '../../../../common/helper'
import DemurrageChrgModal from './DemurrageChrgModal'
import { useTranslation } from '../../../../../i18n/I18nProvider'
const DemurrageChrgTable = (props) => {
  const { updateModal, reportData, showModal, modalType, getDemurrageChrgList,UseToPayAsCOD } = props
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [tableData, setTableData] = useState()
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  const [editableData, setEditableData] = useState()
  const columnDefs = [
    { headerName: tr('gsSN', 'SN'), headerSx: { minWidth: '10px' }, field: 'SN', dataType: 'string', showfilter: false, allowSorting: false },
    {
      headerName: tr('gsChrgTypeShort', 'Chrg. Type'),
      headerSx: { minWidth: '120px' },
      field: 'ChargeType',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsCnsType', 'Consignment Type'),
      headerSx: { minWidth: '160px' },
      field: 'ConsignmentType',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsPayType', 'Payment Type'),
      headerSx: { minWidth: '150px' },
      field: 'PaymentType',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsFixedChrgShort', 'Fixed Chrg.'),
      headerSx: { minWidth: '100px' },
      field: 'FixedCharges',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsAfterDays', 'After Days'),
      headerSx: { minWidth: '90px' },
      field: 'AfterDays',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsDemChgShort', 'Dem. Chrg.'),
      headerSx: { minWidth: '100px' },
      field: 'DemurrageCharges',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsMaxDem', 'Max Dem.'),
      headerSx: { minWidth: '100px' },
      field: 'MaxDemurrage',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsMaxDemChg', 'Max Dem. Chrg.'),
      headerSx: { minWidth: '125px' },
      field: 'MaxDemurrageCharge',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('gsModBy', 'Modified By'),
      headerSx: { minWidth: '140px' },
      field: 'ModifiedUser',
      dataType: 'string',
      showfilter: true,
      allowSorting: true,
    },
    {
      headerName: tr('gsModDt', 'Modified Date & Time'),
      headerSx: { minWidth: '160px' },
      field: 'ModifiedDate',
      dataType: 'time',
      showfilter: false,
      allowSorting: true,
    },
    { headerName: tr('gsActive', 'Active'), headerSx: { minWidth: '20px' }, field: 'Active', dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: tr('gsEdit', 'Edit'), headerSx: { minWidth: '40px' }, field: 'Edit', dataType: 'string', showfilter: false, allowSorting: false },
  ]
  useEffect(() => {
    setTableData(reportData)
    // setTableData(reportData.sort((a, b) => a.ConsignmentType.localeCompare(b.ConsignmentType)))
  }, [reportData])
  const sortTable = (e, field, sortOrder, type) => {
    e.stopPropagation()
    setOrder(sortOrder)
    setOrderBy(field)
    const sortedData = sortTableData(e, field, sortOrder, type, tableData)
    setTableData(sortedData)
  }
  const updateDemurrageChrgModal = () => {
    const propsData = {
      isUpdate: true,
      headText: tr('gsUpdDemChg', 'Update Demurrage Charge'),
      existingData: editableData,
    }
    return <DemurrageChrgModal  UseToPayAsCOD={UseToPayAsCOD} propsData={propsData} getDemurrageChrgList={getDemurrageChrgList} />
  }
  const handleSearchData = (event, index) => {
    let filterData
    if (index === 1) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.ChargeTypeDesc.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else if (index === 2) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.SubType.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else if (index === 3) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.PaymentType.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else if (index === 4) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.IsFixed.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else if (index === 5) {
      filterData = reportData.filter((val) => event.target.value === '' || val.AfterDays.toString().includes(event.target.value.toString()))
    } else if (index === 6) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.DemurrageCharge.toString().includes(event.target.value.toString())
      )
    } else if (index === 7) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.IsMaxDemurrageChg.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else if (index === 8) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.MaxDemurrageChg.toString().includes(event.target.value.toString())
      )
    } else if (index === 9) {
      filterData = reportData.filter(
        (val) => event.target.value === '' || val.ModifiedUser.toLowerCase().includes(event.target.value.toLowerCase())
      )
    }

    setTableData(filterData)
  }
  return (
    <>
      <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '60vh', marginBottom: '5px' }}>
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
            <TableRow>
              {columnDefs.map((col, index) => (
                <TableCell
                  key={`TH-${index}`}
                  style={{
                    ...col.headerSx,
                    backgroundColor: '#DAEDFE',
                    minHeight: '36px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#444',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>{col.headerName}</span>
                    {col.allowSorting && (
                      <span className="SortingIcons">
                        <span
                          className={`up ${orderBy === col.field && order === 'asc' ? 'active' : ''}`}
                          onClick={(e) => sortTable(e, col.field, 'asc', col.dataType)}
                        >
                          <FontAwesomeIcon icon={faCaretUp} transform="shrink-2" />
                        </span>
                        <span
                          className={`down ${orderBy === col.field && order === 'desc' ? 'active' : ''}`}
                          onClick={(e) => sortTable(e, col.field, 'desc', col.dataType)}
                        >
                          <FontAwesomeIcon icon={faCaretDown} transform="shrink-2" />
                        </span>
                      </span>
                    )}
                  </div>
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {columnDefs.map((col, index) =>
                col.showfilter ? (
                  <TableCell key={`FTH-${index}`}>
                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                      <input
                        id={`filter-${index}`}
                        className="field"
                        name="cancelSearchInput"
                        style={{ width: '100%', height: '24px' }}
                        placeholder={tr('gsContains', 'Contains')}
                        onChange={(event) => handleSearchData(event, index)}
                      />
                      <FilterAltIcon style={{ color: '#aaa' }} />
                    </div>
                  </TableCell>
                ) : (
                  <TableCell></TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.length > 0 ? (
              tableData?.map((val, index) => (
                <TableRow key={`DR-${index}`}>
                  <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{index + 1}</TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                    {val.ChargeTypeDesc === 'Per UNIT' || val.ChargeTypeDesc === 'Per Unit' ? tr('gsPerUnit', 'Per Unit') : val.ChargeTypeDesc}
                  </TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.SubType}</TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.PaymentType}</TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.IsFixed}</TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.AfterDays}</TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>
                    {val.DemurrageCharge}
                  </TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                    {val.IsMaxDemurrageChg}
                  </TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>
                    {val.MaxDemurrageChg}
                  </TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '140px' }}>
                    <Tooltip
                      title={`${val.ModifiedUser}(${val.UserBranch})`}
                      PopperProps={{
                        sx: {
                          '& .MuiTooltip-tooltip': {
                            backgroundColor: '#DAEDFE',
                            color: '#000',
                            minHeight: '26px',
                            display: 'flex',
                            fontWeight: '400',
                            alignItems: 'center',
                            marginTop: '5px !important',
                            fontSize: '12px',
                          },
                        },
                      }}
                      placement="bottom-start"
                    >
                      <span
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: 'block',
                          cursor: 'pointer',
                          textDecoration: 'underline',
                        }}
                        onMouseOut={(e) => (e.currentTarget.style.color = '#444')}
                        onMouseOver={(e) => (e.currentTarget.style.color = '#0086FF')}
                      >
                        {val.ModifiedUser}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                    {moment(val.ModifiedDate).format('HH:mm, DD-MMM-YY')}
                  </TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                    <Checkbox checked={!val.IsActive == 0} sx={{ padding: 0 }} />
                    {/* "IsActive" */}
                  </TableCell>
                  <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', cursor: 'pointer' }}>
                    <span
                      id={`Edit-${index}`}
                      tabIndex={0}
                      style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                      onClick={() => {
                        setEditableData(val)
                        updateModal(true, 'updateDemurrageChrgModal')
                        updateDemurrageChrgModal(val)
                      }}
                      // onKeyDown={(e) => navigation3(e, showTableData.length === index + 1 ? "index-1" : `Edit-${index + 1}`, index === 0 ? `index-10` : `Edit-${index - 1}`, () => { setEditableData(item); updateModal(true, "UpdateConsignmentType") })}
                    >
                      <EditIcon sx={{ marginRight: '3px' }} />
                      {tr('gsEdit', 'Edit')}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columnDefs.length}
                  sx={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666', fontWeight: 600 }}
                >
                  {tr('gsNoRecord', 'No Record')}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {showModal && mdt.updateDemurrageChrgModal === modalType ? updateDemurrageChrgModal() : null}
    </>
  )
}

export default DemurrageChrgTable
